import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule} from '@angular/material/badge';
import {MatIconModule} from '@angular/material/icon';
// import {MatDividerModule} from '@angular/material/divider';

@Component({
  selector: 'manage-button',
  standalone: true,
  imports: [
    CommonModule,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
  ],
  template: `
    <!--<button
      class="manage-user-button dp-secondary-btn "
      (click)="onCellClick(rowData)"
    >
      {{ label }}
    </button> -->
    <div style="margin-left: 1rem;display:flex;justify-content: end;gap: 15px;">
        <div *ngIf="rowData.su_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Special Level Accesses" (click)="onCellClick(rowData, 'SU')">
                SU
            </button>
        </div>
        <div *ngIf="rowData.ra_role_count > 0">
            <button mat-mini-fab matBadge="{{rowData.ra_role_count}}" matBadgePosition="before" color="primary" aria-label="Report Level Accesses" (click)="onCellClick(rowData, 'RA')">
                RA
            </button>
        </div>
        <!-- <div *ngIf="rowData.ukw_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Worker Level Accesses" (click)="onCellClick(rowData, 'UKW')">
                UKW
            </button>
        </div> -->
        <div *ngIf="rowData.mw_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Worker Level Accesses" (click)="onCellClick(rowData, 'MW')">
                MW
            </button>
        </div>
        <div *ngIf="rowData.dpu_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Worker Level Accesses" (click)="onCellClick(rowData, 'DPU')">
                DPU
            </button>
        </div>
        <div *ngIf="rowData.jk_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Worker Level Accesses" (click)="onCellClick(rowData, 'JK')">
                JK
            </button>
        </div>
        <div *ngIf="rowData.adj_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Worker Level Accesses" (click)="onCellClick(rowData, 'ADJ')">
                ADJ
            </button>
        </div>
        <div *ngIf="rowData.spr_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Worker Level Accesses" (click)="onCellClick(rowData, 'SPR')">
                SPR
            </button>
        </div>
        <div *ngIf="rowData.pr_role_count > 0">
            <button mat-mini-fab color="primary" aria-label="Worker Level Accesses" (click)="onCellClick(rowData, 'PR')">
                PR
            </button>
        </div>
        <div *ngIf="rowData.sa_role_count > 0">
            <button mat-mini-fab matBadge="{{rowData.sa_role_count}}" matBadgePosition="before" color="primary" aria-label="State Level Accesses" (click)="onCellClick(rowData, 'SL')">
                SL
            </button>
        </div>
        <div *ngIf="rowData.da_role_count > 0">
            <button mat-mini-fab matBadge={{rowData.da_role_count}} matBadgePosition="before" color="accent" aria-label="District Level Accesses" (click)="onCellClick(rowData, 'DL')">
                DL
            </button>
        </div>
        <div *ngIf="rowData.fw_role_count > 0">
            <button mat-mini-fab matBadge={{rowData.fw_role_count}} matBadgePosition="before" color="warm" aria-label="Field Level Accesses" (click)="onCellClick(rowData, 'FL')">
                FL
            </button>
        </div>
        <button mat-mini-fab matBadgePosition="before" color="primary" aria-label="Add New Access" (click)="onCellClick(rowData, 'ALL')">
            +
        </button>
    </div>
  `,
  styles: [
    `
      .manage-user-button {
        width: 78px;
        height: 34px;
      }
    `,
  ],
})
export class ManageButtonComponent {
  @Input() label: string = 'Manage';
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  onCellClick(rowData: any, level: string = '') {
    console.log("Row data: ", level, rowData);
    switch (level) {
        case 'JK':
            rowData.showPermissionLevel = 'JAJAK WORKER';
            this.cellClick.emit(rowData);
            break;
        case 'ADJ':
            rowData.showPermissionLevel = 'ADHURJYA WORKER';
            this.cellClick.emit(rowData);
            break;
        case 'SPR':
            rowData.showPermissionLevel = 'PR/SPR WORKER';
            this.cellClick.emit(rowData);
            break;
        case 'PR':
            rowData.showPermissionLevel = 'PR/SPR WORKER';
            this.cellClick.emit(rowData);
            break;
        case 'RA':
            rowData.showPermissionLevel = 'REPORT LEVEL';
            this.cellClick.emit(rowData);
            break;
        case 'SU':
            rowData.showPermissionLevel = 'SPECIAL LEVEL';
            this.cellClick.emit(rowData);
            break;
        case 'SL':
            rowData.showPermissionLevel = 'STATE LEVEL';
            this.cellClick.emit(rowData);
            break;

        case 'DL':
            rowData.showPermissionLevel = 'DISTRICT LEVEL';
            this.cellClick.emit(rowData);
            break;

        case 'FL':
            rowData.showPermissionLevel = 'FIELD LEVEL';
            this.cellClick.emit(rowData);
            break;
        // case 'UKW':
        //     rowData.showPermissionLevel = 'UK WORKER';
        //     this.cellClick.emit(rowData);
        //     break;
        
        case 'MW':
            rowData.showPermissionLevel = 'MANDIR WORKER';
            this.cellClick.emit(rowData);
            break;
        
        case 'DPU':
            rowData.showPermissionLevel = 'DP ENTRY USER';
            this.cellClick.emit(rowData);
            break;

        case 'ALL':
            rowData.showPermissionLevel = 'ALL LEVEL';
            this.cellClick.emit(rowData);
            break;
    
        default:
            this.cellClick.emit(rowData);
            break;
    }
  }
}
